<template>
  <div class="opple-config-topBar">
    <div
      v-if="hasData"
      class="opple-config-topBar_delete"
      @click="onDeleteIfttt"
    >
      <i
        v-if="isDeleteLoading"
        class="el-icon-loading"
      />
      <i
        v-else
        class="el-icon-delete"
      />
      {{ $t('projectList.delete') }}
    </div>
    <div
      v-if="!hasData"
      class="opple-config-topBar_add"
      @click="showDeviceDialog"
    >
      + {{ $t('ifttt.addObject') }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'OppleConfigTopBar',
  components: {
  },
  props: {
    isDeleteLoading: {
      type: Boolean,
      default: false
    },
    hasData: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },

  computed: {

  },

  watch: {

  },

  mounted() {
    // this.deviceCardList = []
  },

  methods: {
    // selectAll() {
    //   this.$emit('selectAll');
    // },
    showDeviceDialog() {
      this.$emit('showDeviceDialog');
    },
    onDeleteIfttt() {
      if (this.isDeleteLoading) return;

      this.$emit('deleteIfttt')
    }
  },
};
</script>

<style lang="scss">
.opple-config-topBar {
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 20px;
  align-items: center;

  &>div {
    margin-right: 20px;
    cursor: pointer;
  }

  &_delete {
    padding: 9px 15px;
    border: 1px solid #1B45A4;
    border-radius: 4px;
    color: #1B45A4;
  }

  &_selectAll {

  }
}

</style>